import { render, staticRenderFns } from "./EditNoteEmail.vue?vue&type=template&id=48ab2ea5"
import script from "./EditNoteEmail.vue?vue&type=script&lang=js"
export * from "./EditNoteEmail.vue?vue&type=script&lang=js"
import style0 from "./EditNoteEmail.vue?vue&type=style&index=0&id=48ab2ea5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports